import React, { useState } from 'react';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { IconArrowLeft, IconDeviceFloppy, IconRobot } from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

import api from '../../../../services/api';

const hostname = window.location.hostname;
let AGENT_SERVER;

// if (hostname.startsWith('crm.')) {
//     AGENT_SERVER = 'https://apichat.loged.com.br';
// } else {
//     AGENT_SERVER = 'http://127.0.0.1:7000';
// }
if (hostname.startsWith('crm.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('glazzbeauty.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('casamathiola.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('bliveinpets.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('acin.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('braza55.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('po.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('florestavet.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('quimicer.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('imobiliaria.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else {
    AGENT_SERVER = 'http://127.0.0.1:7000';
}

// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'https://apichat.loged.com.br';

const agentApi = axios.create({
    baseURL: AGENT_SERVER
});

agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

const AGENT_TYPES = [
    {
        value: 'client_chatbot',
        label: 'Assistente para os clientes'
    },
    {
        value: 'attendant_chatbot',
        label: 'Assistente para um atendente'
    },
    {
        value: 'admin_chatbot',
        label: 'Assistente administrador do sistema'
    },
    {
        value: 'system',
        label: 'Assistente para automações'
    }
];

const CreateAgent = () => {
    const history = useHistory();

    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState({
        type: '',
        message: ''
    });

    const [form, setForm] = useState({
        name: '',
        agent_type: 'system',
        system_prompt: ''
    });

    const handleChange = (field, value) => {
        setForm((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const criarAgente = async () => {
        setStatus({
            type: '',
            message: ''
        });

        if (!form.name.trim()) {
            setStatus({
                type: 'error',
                message: 'Digite o nome do agente.'
            });
            return;
        }

        if (!form.system_prompt.trim()) {
            setStatus({
                type: 'error',
                message: 'Digite a instrução para o seu assistente..'
            });
            return;
        }

        setLoading(true);

        try {
            const appResponse = await api.get('v1/apps/default/');

            const appId = appResponse.data?.app?.id;
            const accountId = appResponse.data?.app?.account;

            if (!appId || !accountId) {
                setStatus({
                    type: 'error',
                    message: 'Não foi possível obter as informações do app.'
                });
                return;
            }

            const payload = {
                name: form.name,
                agent_type: form.agent_type,
                system_prompt: form.system_prompt
            };

            const response = await agentApi.post(`/agent/api/v1/account/${accountId}/app/${appId}/agents/`, payload);

            if (response.data?.created) {
                setStatus({
                    type: 'success',
                    message: 'Agente criado com sucesso.'
                });

                setTimeout(() => {
                    history.push('/dashboard/config/agents/view');
                }, 1000);
            }
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao criar agente.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            {/* HEADER */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 4,
                    flexWrap: 'wrap',
                    gap: 2
                }}
            >
                <Box>
                    <Button
                        startIcon={<IconArrowLeft size={18} />}
                        onClick={() => history.goBack()}
                        sx={{
                            mb: 2,
                            textTransform: 'none'
                        }}
                    >
                        Voltar
                    </Button>

                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 800,
                            background: 'linear-gradient(90deg, #1976d2, #9c27b0)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            lineHeight: 1.2
                        }}
                    >
                        Criar Agente
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            mt: 0.5
                        }}
                    >
                        Configure um novo agente inteligente
                    </Typography>
                </Box>
            </Box>

            {status.message && (
                <Alert
                    severity={status.type}
                    sx={{
                        mb: 3,
                        borderRadius: '12px'
                    }}
                >
                    {status.message}
                </Alert>
            )}

            <Grid container justifyContent="center">
                <Grid item xs={12} md={10} lg={8}>
                    <Card
                        sx={{
                            borderRadius: '20px',
                            boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                            border: '1px solid #e2e8f0',
                            overflow: 'hidden'
                        }}
                    >
                        {/* TOP HEADER */}
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, #1976d2 0%, #9c27b0 100%)',
                                p: 3,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <Box
                                sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: '16px',
                                    background: 'rgba(255,255,255,0.15)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                <IconRobot size={30} color="#fff" />
                            </Box>

                            <Box>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 800
                                    }}
                                >
                                    Novo Agente
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'rgba(255,255,255,0.8)'
                                    }}
                                >
                                    Configure o comportamento do agente
                                </Typography>
                            </Box>
                        </Box>

                        <CardContent
                            sx={{
                                p: 4
                            }}
                        >
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Nome do Agente"
                                        value={form.name}
                                        onChange={(e) => handleChange('name', e.target.value)}
                                        placeholder="Ex: Assistente Financeiro"
                                        variant="outlined"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '14px'
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Tipo do Agente"
                                        value={form.agent_type}
                                        onChange={(e) => handleChange('agent_type', e.target.value)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '14px'
                                            }
                                        }}
                                    >
                                        {AGENT_TYPES.map((type) => (
                                            <MenuItem key={type.value} value={type.value}>
                                                {type.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={10}
                                        label="Instruções"
                                        value={form.system_prompt}
                                        onChange={(e) => handleChange('system_prompt', e.target.value)}
                                        placeholder="Digite aqui o comportamento, regras e instruções do agente..."
                                        variant="outlined"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '14px'
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            gap: 2,
                                            mt: 2
                                        }}
                                    >
                                        <Button
                                            variant="outlined"
                                            onClick={() => history.goBack()}
                                            sx={{
                                                borderRadius: '12px',
                                                px: 3,
                                                textTransform: 'none',
                                                fontWeight: 600
                                            }}
                                        >
                                            Cancelar
                                        </Button>

                                        <Button
                                            variant="contained"
                                            startIcon={
                                                loading ? <CircularProgress size={18} color="inherit" /> : <IconDeviceFloppy size={18} />
                                            }
                                            onClick={criarAgente}
                                            disabled={loading}
                                            sx={{
                                                borderRadius: '12px',
                                                px: 3,
                                                py: 1.2,
                                                fontWeight: 700,
                                                textTransform: 'none',
                                                background: 'linear-gradient(135deg, #1976d2, #9c27b0)',
                                                boxShadow: '0 8px 20px rgba(25,118,210,0.3)',
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #1565c0, #7b1fa2)'
                                                }
                                            }}
                                        >
                                            {loading ? 'Criando...' : 'Criar Agente'}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CreateAgent;
